const ValidationErrorLogApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/validationController/get`,
  DELETE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/validationController/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/validationController/download`
};

export default ValidationErrorLogApiUrls
